<!--
<div class="auth-layout-wrap"
    style="background-image: url(./assets/images/photo-wide-4.jpg)">
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
</div>
-->
<div class="auth-layout-wrap">
    <div class="auth-content">
        <router-outlet></router-outlet>
        <section class="copyright-footer-auth">
            <span>&copy; {{year}} IND - Todos los derechos reservados.</span>
        </section>
    </div>
</div>
